import { CanDeactivateFn } from '@angular/router';
import { CanDeactivate } from './can-deactivate';

export const canDeactivateGuard: CanDeactivateFn<CanDeactivate> = (component, currentRoute, currentState, nextState) => {
  return component.canDeactivate();
};
